import { SVGProps } from "react";

const GIStar = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" width="1em" height="1em" {...props}><circle cx={128} cy={128} r={128} /><circle stroke="#fff" strokeWidth={18} cx={128} cy={128} r={101} /><path fill="#fff" d="M128 53.524l-17.354 51.819-54.646.492 43.92 32.518-16.418 52.123L128 158.754l44.498 31.722-16.418-52.123L200 105.835l-54.646-.492z" /></svg>;

export { GIStar };